import React, { RefObject } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { usePayrollFinancialAccounts } from "@hooks/useFinancialAccounts";
import { useCanPerformWorkspaceAction } from "@hooks/permissions/useCanPerformWorkspaceAction";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { AccountsSettings } from "../Accounts/AccountsSettings";
import { Payroll } from "../Payroll/Payroll";
import { useEntity } from "../../entity/useEntity";
import { EntityLogoUploadProvider } from "./EntityLogoUploadProvider";
import { EntityGeneralSettings } from "./EntityGeneralSettings";
import { KickAISettings } from "./KickAISettings";
import { CategorizationSettings } from "./Categorization/CategorizationSettings";
import { EntityDeleteSection } from "./EntityDeleteSection";

interface Props {
    scrollbars: RefObject<Scrollbars | null>;
}

export const EntitySettings: React.FC<Props> = ({ scrollbars }) => {
    const entity = useEntity();
    const hasPayroll =
        usePayrollFinancialAccounts({ entityId: entity.id }).length > 0;

    const canManageEntitySettings = useCanPerformWorkspaceAction(
        WorkspaceAction.ENTITY_SETTINGS_EDIT,
    );
    const canViewPayroll = useCanPerformWorkspaceAction(
        WorkspaceAction.PAYROLL_VIEW,
    );

    const { entityCategorizationSettings } = useTypedFlags();

    const showPayroll =
        canViewPayroll &&
        !entity.isPersonal &&
        !entity.isMockEntity &&
        hasPayroll;
    const showCategorization =
        entityCategorizationSettings &&
        !entity.isPersonal &&
        !entity.isMockEntity &&
        entity.hasCustomChartOfAccounts;

    return (
        <>
            <header className="settings__header">
                <div>
                    <h3>{entity.name}</h3>
                </div>
            </header>

            {canManageEntitySettings && (
                <EntityLogoUploadProvider>
                    <EntityGeneralSettings />
                </EntityLogoUploadProvider>
            )}

            {canManageEntitySettings &&
                !entity.isPersonal &&
                !entity.isMockEntity && <KickAISettings />}

            <EntityDeleteSection />

            <AccountsSettings scrollbars={scrollbars} />

            {showPayroll && <Payroll />}

            {showCategorization && <CategorizationSettings />}
        </>
    );
};
